import { useQuery } from "@tanstack/react-query";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { MarketCard, type Market } from "../components/MarketCard";
import { MarketCover } from "../components/MarketCover";

export function TopicPage() {
  const { slug } = useParams();
  const q = useQuery({
    queryKey: ["topic", slug],
    queryFn: () =>
      api<{ group: { slug: string; title: string; blurb: string; accent: string; image_url?: string; image_fit?: "cover" | "contain" | "portrait" }; markets: Market[] }>(
        `/markets/groups/${slug}`,
      ),
    enabled: !!slug,
  });
  if (q.isLoading) return <div className="wrap"><div className="skeleton" style={{ height: 40 }} /></div>;
  if (!q.data) {
    return (
      <div className="wrap empty">
        <h3>That event isn’t live.</h3>
        <p>Browse the marketplace for contracts that are open now.</p>
        <Link to="/markets" className="btn btn-primary">All markets</Link>
      </div>
    );
  }
  const { group, markets } = q.data;
  const top = markets[0];
  return (
    <div className="wrap">
      <div className="topic-hero card">
        <MarketCover
          accent={group.accent}
          eventSlug={group.slug}
          probability={top?.yes_price_cents}
          imageUrl={group.image_url || top?.image_url}
          fit={group.image_fit || top?.image_fit}
        />
        <div>
          <span className="kicker">Event</span>
          <h1>{group.title}</h1>
          <p>{group.blurb}</p>
          <p style={{ color: "var(--muted)" }}>{markets.length} related contracts — same story, different thresholds.</p>
        </div>
      </div>
      <div className="grid-3" style={{ marginTop: 22 }}>
        {markets.map((m) => <MarketCard key={m.id} market={m} />)}
      </div>
    </div>
  );
}
